import * as Yup from 'yup'

export const UserSchema = Yup.object().shape({
    email: Yup
        .string()
        .email()
        .nullable()
        .label('Email')
        .required(),

    first_name: Yup
        .string()
        .nullable()
        .label('First Name')
        .required('First name is required'),

    last_name: Yup
        .string()
        .nullable()
        .label('Last Name')
        .required('Last name is required'),

    password: Yup
        .string()
        .when(['isEdit'], {
            is: (isEdit) => isEdit,
            then: Yup.string(),
            otherwise: Yup.string().min(8)
                .label('Password')
                .matches(/^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,}$/, 'Password must container 1 letter, 1 number, and 1 special character')
                .required('Password is required')
        }),

    password_confirm: Yup
        .string()
        .when(['isEdit'], {
            is: (isEdit) => isEdit,
            then: Yup.string(),
            otherwise: Yup.string().min(8)
                .label('Confirm Password')
                .required('Please confirm your password')
                .matches(/^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,}$/, 'Password must container 1 letter, 1 number, and 1 special character')
                .test('passwords-match', 'Passwords do not match', function (value) {
                    return this.parent.password === value
                })
        }),

    role: Yup.object().shape({
        id: Yup.mixed(),
        name: Yup.string()
    })
        .nullable()
        .default(null)
        .required('Role is required'),

    preliminary_estimate_action: Yup.object().shape({
        id: Yup.mixed(),
        name: Yup.string()
    })
        .nullable()
        .default(null)
        .required(),

    employee: Yup.object().shape({
        id: Yup.mixed(),
        name: Yup.string(),
    })
        .nullable()
        .default(null)
        .test({
            name: 'subcontractor-mismatch',
            exclusive: false,
            message: 'This Employee is not of the same subcontractor status as this User',
            test: function (value) {
                const subcontractorPermission = this.parent.user_permissions.biPermissions
                    .find(x => x.category_name === 'is_subcontractor')
                return !value?.id || (value?.id && value.is_subcontractor === subcontractorPermission.has_permission)
            }
        }),

    is_central_tx_job_created_notification_recipient: Yup.boolean().required(),

    is_email_transmission_failed_notification_recipient: Yup.boolean().required(),

    user_permissions: Yup.object().shape({
        biPermissions: Yup.array(Yup.object().shape({
            category_name: Yup.string().required(),
            has_permission: Yup.bool().required()
        })),
        triPermissions: Yup.array(Yup.object().shape({
            category_name: Yup.string().required(),
            access_level: Yup.object().shape({
                name: Yup.string().required(),
                id: Yup.number().required()
            })
        })),
    })
}, [])